export const omit = <T>(obj: T, props: (keyof T)[]) => {
    obj = { ...obj }
    props.forEach((prop) => delete obj[prop])
    return obj
}

export const isEmpty = (obj: any) =>
    [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length
